export default "__VITE_ASSET__BUVWK5D$__"